import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=0b09972f"
import script from "./login-form.vue?vue&type=script&lang=js"
export * from "./login-form.vue?vue&type=script&lang=js"
import style0 from "./login-form.vue?vue&type=style&index=0&id=0b09972f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b09972f')) {
      api.createRecord('0b09972f', component.options)
    } else {
      api.reload('0b09972f', component.options)
    }
    module.hot.accept("./login-form.vue?vue&type=template&id=0b09972f", function () {
      api.rerender('0b09972f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/login/login-form.vue"
export default component.exports